import { log } from '@/utils/common';
import greedyKeyReactor from '@/utils/greedy-key-reactor';

function getLayoutVm() {
  if (this.$children[0].$vnode.componentOptions.tag === 'modal-layout') {
    return this.$children[0];
  }
  throw new Error('looks like modal layout component does\'nt exist.');
}

function keydownHandler(keyCode) {
  console.log(`got a key code: ${keyCode}`, this);
}

export default {
  data() {
    return {
      showing: false,
    };
  },
  methods: {
    open() {
      const vm = getLayoutVm.call(this);
      vm.open();
      this.showing = true;
      this.keydownHandler = keydownHandler.bind(this);
      greedyKeyReactor.subscribe(this.keydownHandler);
    },
    close() {
      const vm = getLayoutVm.call(this);
      vm.dispose();
      this.beforeClose();
      this.showing = false;
    },
    onDispose() {
      if (typeof this.onBeforeDispose === 'function') {
        this.onBeforeDispose();
      }
      log('modal-mixin::onDispose', 'mixin dispose');
      const vm = getLayoutVm.call(this);
      vm.dispose();
      this.beforeClose();
      this.showing = false;
      this.$emit('dispose');
    },
    beforeClose() {
      greedyKeyReactor.unsubscribe(this.keydownHandler);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/global/modal-mixin.js